module.exports = __webpack_public_path__ + "static/media/tapir-pink.bd13d021.png";